<template>
  <div class="discipline" v-if="status">
    <div class="content">
      <div class="title">
        开庭纪律
        <img @click="_close" class="click" src="../assets/icon_close.png" alt />
      </div>
      <div class="info">
        <div>
          <p style="text-align:center;font-size: 18px">湛江仲裁委员会（湛江国际仲裁院）</p>

          <p align="center" style="text-align:center;font-size: 18px">视频开庭纪律</p>

          <p>一、本案使用视频开庭方式审理，依法不公开进行，通知到庭人员首先要接受通过网络图像和身份证确认身份，其他人员不得进入视频区。</p>

          <p>二、当事人必须服从仲裁庭的指挥、传唤和询问。</p>

          <p>三、当事人陈述事实、辩论问题及其他发言，要实事求是，语言举止文明礼貌，未经仲裁庭许可不得发言。</p>

          <p>四、不得录相、录音和拍照，不得将开庭过程向外传播，违者要承担法律责任。</p>

          <p>五、不得自行离座走动或者中断视频活动，违者视为缺席开庭。</p>

          <p>六、不得出现大声喧哗、吵闹和其他妨碍视频开庭活动的行为，对庭审过程有意见可以当庭或者休庭后提出。</p>

          <p>七、不得擅自使用其他通讯工具干扰庭审活动。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    status: {
      default: false
    }
  },
  data () {
    return {}
  },
  methods: {
    _close () {
      this.$emit('handle', { type: 0, event: -1 })
    }
  }
}
</script>

<style lang="scss">
@import "../style/mixin";
.discipline {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: 100;
  background-color: rgba(0, 0, 0, 0.3);
  .content {
    @include center;
    background-color: #fff;
    width: 7rem;
    border-radius: 0.042rem;
    overflow: hidden;
    .code {
      text-align: center;
      margin-top: 0.208rem;
      img {
        width: 1.442rem;
        height: 1.442rem;
      }
      p {
        font-size: 0.15rem;
        font-family: PingFang SC;
        font-weight: bold;
        padding-top: 0.183rem;
        padding-bottom: 0.192rem;
      }
    }
    .btn {
      text-align: center;
      padding-bottom: 0.275rem;
      button {
        background-color: #267cd0;
        color: #fff;
        padding: 0.025rem 0.1rem;
        border-radius: 0.13rem;
        margin: 0 0.1rem;
        font-size: 0.133rem;
        font-family: PingFang SC;
        font-weight: 500;
        color: rgba(255, 255, 255, 1);
      }
    }
    .info {
      padding: 0.2rem 0.2rem;
      & > div {
        font-size: 0.133rem;
        font-family: PingFang SC;
        font-weight: 500;
        color: #272727;
        line-height: 30px;
      }
    }
    .title {
      height: 0.442rem;
      line-height: 0.442rem;
      font-size: 0.15rem;
      font-family: PingFang SC;
      font-weight: bold;
      text-align: center;
      background-color: #cdd8e7;
      position: relative;
      img {
        position: absolute;
        z-index: 2;
        right: 0.133rem;
        top: 0.125rem;
        @include wh(0.2rem, 0.2rem);
      }
    }
  }
}
</style>
